<script setup lang="ts">

import { ref } from "vue";
import type { ConfigureConditionViewModel } from "..";

const model = defineModel<ConfigureConditionViewModel>( { required: true } );
const months = model.value.getPastMonthlyRange( 24 );
const showRange = ref( 12 );

</script>

<template>

    <div class="text-base text-center flex flex-col pt-2 pb-10">

        <Spacer />

        <h1 class="tracking-wider opacity-60 mt-4 px-8 lg:px-12">
            When did you last have this last done?
        </h1>

        <div class="mt-3 tracking-widest text-amber-500 dark:text-amber-400 uppercase">
            {{ model.labels.timespan }}
        </div>

        <div class="mb-6 tracking-widest text-amber-500 dark:text-amber-400 uppercase text-sm opacity-60">
            {{ model.labels.date }}
        </div>

        <div class="grid grid-cols-4  tracking-widest">
        
            <template v-for="(date,index) in months">
                <div v-if="date.month() == 11 && index < showRange"
                     class="col-span-4 py-2 dark:bg-gray-800">
                    {{ date.year() }}
                    <ContentSpacer class="mt-2" />
                </div>
                <div v-ripple
                     v-if="index < showRange"
                     class="aspect-square flex flex-col items-center justify-center dark:bg-gray-800"
                     :class="{ 'text-secondary-400': date.isSame( model.today, 'month' ) }"
                     @click="() => model.onSelectLastDone( date )">
                    <div v-if="date.isSame( model.selected, 'month' )"
                         class="rounded-full border-[4px] border-secondary-500 absolute w-3/4 h-3/4">
                    </div>
                    <Icon v-if="date.isSame( model.today, 'month' )" 
                          name="car-side" 
                          class="text-2xl -mb-1" />
                    <div>{{ date.format( 'MMM') }}</div>
                </div>
            </template>

            <div class="col-span-4 flex flex-col dark:bg-gray-800">
                <ContentSpacer />
                <button v-ripple
                        class="py-4 tracking-widest flex items-center justify-center"
                        @click="() => showRange = ( showRange == 12 ? 24 : 12 )">
                    {{ showRange == 24 ? 'Show Less' : 'Show More' }}
                    <Icon v-if="showRange == 24" name="chevron-up" class="text-2xl" />
                    <Icon v-else name="chevron-down" class="text-2xl" />
                </button>
            </div>

        </div>
    </div>

</template>